import { render, staticRenderFns } from "./VoyageBinding.vue?vue&type=template&id=3eb2957c&scoped=true"
import script from "./VoyageBinding.vue?vue&type=script&lang=js"
export * from "./VoyageBinding.vue?vue&type=script&lang=js"
import style0 from "./VoyageBinding.vue?vue&type=style&index=0&id=3eb2957c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb2957c",
  null
  
)

export default component.exports